import React, { useState, useRef, useEffect, memo } from 'react';

interface PromptInputProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  disabled?: boolean;
  minHeight?: number;
  maxHeight?: number;
}

const PromptInputInner: React.FC<PromptInputProps> = ({
  value,
  placeholder = '描述您的生成需求...',
  onChange,
  onSubmit,
  disabled = false,
  minHeight = 120,
  maxHeight = 200,
}) => {
  const [height, setHeight] = useState(minHeight);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.min(Math.max(textareaRef.current.scrollHeight, minHeight), maxHeight);
      setHeight(newHeight);
    }
  }, [value, minHeight, maxHeight]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault();
      onSubmit?.();
    }
  };

  return (
    <div className="relative group/input bg-black/10 rounded-[16px]">
      <textarea
        ref={textareaRef}
        className="w-full bg-transparent text-xs text-slate-200 placeholder-slate-500/60 p-3 focus:outline-none resize-none custom-scrollbar font-medium leading-relaxed"
        style={{ height: `${height}px` }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
    </div>
  );
};

export const PromptInput = memo(PromptInputInner, (prevProps, nextProps) => {
  return (
    prevProps.value === nextProps.value &&
    prevProps.placeholder === nextProps.placeholder &&
    prevProps.disabled === nextProps.disabled &&
    prevProps.minHeight === nextProps.minHeight &&
    prevProps.maxHeight === nextProps.maxHeight
  );
});